interface User {
  user_id: number;
  chapter_id: number;
  role_id: number;
  year: number;
}

export async function getProgramUsers() {
  return await fetch("/api/users/program")
    .then((resp) => resp.json())
    .then((data) => data);
}

export async function getAllUsers() {
  return await fetch("/api/users")
    .then((resp) => resp.json())
    .then((data) => data);
}

// Only the accounts that impersonation can actually take effect for — those
// holding a role in the current program year. The general /api/users list is
// deliberately unfiltered because the "Add a User Role" flow needs people who
// are not in this year's program yet.
export async function getSimulationCandidates() {
  return await fetch("/api/users/simulation-candidates")
    .then((resp) => resp.json())
    .then((data) => data);
}

export async function saveUser(user: User) {
  return await fetch("/api/users", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  });
}

export async function removeUser(user: User) {
  return await fetch("/api/users", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(user),
  });
}

export async function getCommittee() {
  return await fetch("/api/users/committee")
    .then((resp) => resp.json())
    .then((data) => data);
}

export async function getOfficerRoleCount(officerRoleId: number){
  return await fetch(`/api/users/getOfficerRoleCount/${officerRoleId}`, {
    credentials: 'include', // Add this for authentication
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((resp) => resp.json())
    .then((data) => data);
}